import { IPaymentsData, IPromoCode, PaymentTypeEnum, PromocodeApplyToTypeEnum, PromocodeDiscountTypeEnum, PromocodeLimitTypeEnum } from "../store/payment/types";
import { mergeObjects } from "./dataManipulations";

export const paymentInitial: IPaymentsData = {
    paymentID: "",
    enablePromocode: true,
    fee: 0,
    paymentMethod: {
        cash: false,
        paypal: false,
        stripe: false,
        square: false,
    },
    account: {
        stripe: {},
        square: {},
        paypal: {
            email: "",
        },
    },
    paymentReceipt: { name: "", email: "example@example.com", phone: "", address: "", enabled: false, template: "" },
    paymentType: PaymentTypeEnum.ONE_TIME,
    shippingFee: 0,
    showTotal: false,
    redirectUrl: "",
    promocodes: [],
    payableFields: {
        ONE_TIME: [],
        SUBSCRIPTION: [],
    },
};

const initialPromoCode = {
    _id: "",
    applyTo: PromocodeApplyToTypeEnum.form,
    code: "",
    discount: "",
    discountType: PromocodeDiscountTypeEnum.percent,
    field: [{ field: "", options: [""] }],
    isActive: true,
    limitCount: "",
    limitDate: "",
    limitType: PromocodeLimitTypeEnum.noLimit,
    payment: "",
};

export const getDeclarablePaymentData = (data?: any) => {
    let payment = {};
    if (data) {
        payment = getObjectPaths(data);
    } else payment = getObjectPaths(paymentInitial);
    return payment;
};

interface IOptions {
    [key: string]: {
        label: string;
        isOther?: boolean | undefined;
    };
}

type PaymentInitial = typeof paymentInitial;

function getObjectPaths(obj: PaymentInitial, prefix = ""): { [key: string]: any } {
    const result: { [key: string]: any } = {};

    for (const key in obj) {
        //@ts-ignore
        const value = obj[key];
        const path = prefix ? `${prefix}.${key}` : key;

        if (
            !Array.isArray(value) &&
            typeof value === "object" &&
            value !== null &&
            key !== "paymentReceipt" &&
            key !== "payableFields"
        ) {
            const nestedPaths = getObjectPaths(value, path);
            Object.assign(result, nestedPaths);
        } else {
            if (key === "promocodes") {
                const completed = completePromoCodesData(value);
                result[path] = completed;
            } else {
                result[path] = value;
            }
        }
    }
    return Object.keys(result).reduce((acc, element) => {
        let modified = {};

        if (element.includes("payment.")) {
            modified = { [element]: result[element] };
        } else {
            modified = { ["payment." + element]: result[element] };
        }
        return { ...acc, ...modified };
    }, {});
}

export const getShowableFieldOptionsList = (options: IOptions) => {
    return Object.keys(options).reduce((acc, element) => {
        return {
            ...acc,
            [element]: options[element].label,
        };
    }, {});
};

function completePromoCodesData(list: IPromoCode[]) {
    return list.map(element => {
        return mergeObjects(initialPromoCode, element);
    });
}

export const toggleFieldPayment = (
    paymentType: PaymentTypeEnum,
    payableFields: IPaymentsData["payableFields"],
    fieldId: string,
    isFieldPayable: boolean,
) => {
    const { ONE_TIME, SUBSCRIPTION } = payableFields;
    let tempOneTime = [...ONE_TIME];
    let tempSubscription = [...SUBSCRIPTION];
    if (!isFieldPayable) {
        window.handleChange({ id: `fields.${fieldId}.paymentOptions.enabled`, value: true });
    }
    if (+paymentType === PaymentTypeEnum.SUBSCRIPTION) {
        if (SUBSCRIPTION.includes(fieldId)) {
            window.handleChange({
                id: "payment.payableFields",
                value: {
                    ONE_TIME,
                    SUBSCRIPTION: SUBSCRIPTION.filter(element => element !== fieldId),
                },
            });
            tempSubscription = SUBSCRIPTION.filter(element => element !== fieldId);
        } else {
            window.handleChange({
                id: "payment.payableFields",
                value: {
                    ONE_TIME,
                    SUBSCRIPTION: [...SUBSCRIPTION, fieldId],
                },
            });
            tempSubscription = [...SUBSCRIPTION, fieldId];
        }
    } else {
        if (ONE_TIME.includes(fieldId)) {
            window.handleChange({
                id: "payment.payableFields",
                value: {
                    ONE_TIME: ONE_TIME.filter(element => element !== fieldId),
                    SUBSCRIPTION,
                },
            });
            tempOneTime = ONE_TIME.filter(element => element !== fieldId);
        } else {
            window.handleChange({
                id: "payment.payableFields",
                value: {
                    ONE_TIME: [...ONE_TIME, fieldId],
                    SUBSCRIPTION,
                },
            });
            tempOneTime = [...ONE_TIME, fieldId];
        }
    }
    if (isFieldPayable && !tempOneTime.includes(fieldId) && !tempSubscription.includes(fieldId)) {
        window.handleChange({ id: `fields.${fieldId}.payableOptions.enabled`, value: false });
    }
};

export const getPayableButtonsDisabled = (
    paymentType: PaymentTypeEnum,
    payableFields: IPaymentsData["payableFields"],
    fieldId: string,
) => {
    const { SUBSCRIPTION } = payableFields;

    if (+paymentType === PaymentTypeEnum.SUBSCRIPTION) {
        if (SUBSCRIPTION.length === 0) {
            return false;
        } else {
            if (SUBSCRIPTION.includes(fieldId)) {
                return false;
            }
            return true;
        }
    } else return false;
};

export const getPayableFieldActivity = (
    payableFields: IPaymentsData["payableFields"],
    paymentType: PaymentTypeEnum,
    fieldId: string,
) => {
    return +paymentType === PaymentTypeEnum.SUBSCRIPTION
        ? payableFields.SUBSCRIPTION.includes(fieldId)
        : payableFields.ONE_TIME.includes(fieldId);
};

export const getPaymentActiveState = (payableFields: IPaymentsData["payableFields"], paymentType: PaymentTypeEnum) => {
    if (+paymentType === PaymentTypeEnum.SUBSCRIPTION) {
        if (payableFields.SUBSCRIPTION.length) {
            return true;
        }
    } else {
        if (payableFields.ONE_TIME.length) {
            return true;
        }
    }

    return false;
};
